import { NewRelicPlusPlugin, EventType, ElementType, EventAction } from '@cof/stratum';

const PLUGINS = [NewRelicPlusPlugin()];
// PRODUCT_NAME is a required export of this file (use your DevNav component name)
const PRODUCT_NAME = 'fs-lienholder-mfe-staticassets';
// PRODUCT_VERSION is a required export of this file
const PRODUCT_VERSION = '2.0.1';
var TagKey;
(function (TagKey) {
    /**
     * Enumerate keys of tag catalog entries here for easy
     * use and consistent reference across your application.
     *
     * The values of the tag keys can be any string or number
     * value. These keys will not be referenced outside
     * of the application.
     */
    TagKey["PAGE_VIEW_COAF_REFI_LIENHOLDER"] = "PAGE_VIEW_COAF_REFI_LIENHOLDER";
    TagKey["LIENHOLDER_NAME_LENDER_NAME_PREFILLED"] = "LIENHOLDER_NAME_LENDER_NAME_PREFILLED";
    TagKey["LIENHOLDER_LENDER_NAME_EDITED"] = "LIENHOLDER_LENDER_NAME_EDITED";
    TagKey["LIENHOLDER_ACCOUNT_NUMBER_LENDER_ACCOUNT_NUMBER_PREFILLED"] = "LIENHOLDER_ACCOUNT_NUMBER_LENDER_ACCOUNT_NUMBER_PREFILLED";
    TagKey["LIENHOLDER_ACCOUNT_NUMBER_EDITED"] = "LIENHOLDER_ACCOUNT_NUMBER_EDITED";
    TagKey["LIENHOLDER_SUBMIT_LENDER_INFO"] = "LIENHOLDER_SUBMIT_LENDER_INFO";
    TagKey["LIENHOLDER_LENDER_UPDATES_SAVE_SUCCESS"] = "LIENHOLDER_LENDER_UPDATES_SAVE_SUCCESS";
    TagKey["LIENHOLDER_LENDER_UPDATES_SAVE_FAILED"] = "LIENHOLDER_LENDER_UPDATES_SAVE_FAILED";
    TagKey["LENDER_CHECKOUT_PAYOFF_AMOUNT_PREFILLED"] = "LENDER_CHECKOUT_PAYOFF_AMOUNT_PREFILLED";
    TagKey["LENDER_CHECKOUT_PAYOFF_AMOUNT_CLICKED"] = "LENDER_CHECKOUT_PAYOFF_AMOUNT_CLICKED";
    TagKey["LENDER_CHECKOUT_UPDATE_LENDER_CLICKED"] = "LENDER_CHECKOUT_UPDATE_LENDER_CLICKED";
    TagKey["LENDER_CHECKOUT_CANCEL_LENDER_CLICKED"] = "LENDER_CHECKOUT_CANCEL_LENDER_CLICKED";
    TagKey["LIENHOLDER_LENDER_INFO_CHANGED"] = "LIENHOLDER_LENDER_INFO_CHANGED";
    TagKey["LENDER_CHECKOUT_MISSING_INFORMATION_ALERT"] = "LENDER_CHECKOUT_MISSING_INFORMATION_ALERT";
    TagKey["LIENHOLDER_FIELD_VALIDATION_ERROR_MESSAGE"] = "LIENHOLDER_FIELD_VALIDATION_ERROR_MESSAGE";
    TagKey["LENDER_CHECKOUT_LENDER_EDIT_ERROR_MESSAGE"] = "LENDER_CHECKOUT_LENDER_EDIT_ERROR_MESSAGE";
    TagKey["VIEW_LENDER_CHECKOUT"] = "VIEW_LENDER_CHECKOUT";
    TagKey["LENDER_CHECKOUT_LENDER_MFE_LOAD"] = "LENDER_CHECKOUT_LENDER_MFE_LOAD";
    TagKey["LENDER_CHECKOUT_LENDER_COMPONENT_COLLAPSED"] = "LENDER_CHECKOUT_LENDER_COMPONENT_COLLAPSED";
    TagKey["CUSTOMER_PROFILE_CUSTOMER_PROFILE_DOC_GENERATED"] = "CUSTOMER_PROFILE_CUSTOMER_PROFILE_DOC_GENERATED";
})(TagKey || (TagKey = {}));
// TAG_CATALOG is a required export of this file
const TAG_CATALOG = {
    /**
     * Add TagCatalog entries here. Best practice
     * is to use enumerated values for the tag keys.
     *
     * For properties with values of a specific type (like eventType),
     * export the corresponding type from the @cof/stratum package.
     */
    [TagKey.PAGE_VIEW_COAF_REFI_LIENHOLDER]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Lienholder Page Viewed',
        tagId: 7001,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'lienholder',
            level4: '',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.LIENHOLDER_NAME_LENDER_NAME_PREFILLED]: {
        eventType: EventType.UI,
        tagDescription: 'Lienholder name prefilled for Customer',
        tagId: 7002,
        rules: {
            applicationId: true,
        },
        featureName: 'Lienholder Name',
        tagName: 'lender name prefilled',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
    },
    [TagKey.LIENHOLDER_LENDER_NAME_EDITED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "Lender Name" input box',
        tagId: 7003,
        rules: {
            applicationId: true,
        },
        featureName: 'Lienholder',
        tagName: 'lender name edited',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
    },
    [TagKey.LIENHOLDER_ACCOUNT_NUMBER_LENDER_ACCOUNT_NUMBER_PREFILLED]: {
        eventType: EventType.UI,
        tagDescription: 'Lienholder Account Number prefilled for user',
        tagId: 7004,
        rules: {
            applicationId: true,
        },
        featureName: 'Lienholder Account Number',
        tagName: 'lender account number prefilled',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
    },
    [TagKey.LIENHOLDER_ACCOUNT_NUMBER_EDITED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "Lender Account Number" input box',
        tagId: 7005,
        rules: {
            applicationId: true,
        },
        featureName: 'Lienholder',
        tagName: 'account number edited',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
    },
    [TagKey.LIENHOLDER_SUBMIT_LENDER_INFO]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Continue" button at the bottom of the LH page ',
        tagId: 7006,
        rules: {
            applicationId: true,
        },
        featureName: 'Lienholder',
        tagName: 'submit lender info',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.LIENHOLDER_LENDER_UPDATES_SAVE_SUCCESS]: {
        eventType: EventType.UI,
        tagDescription: 'System saves user updates',
        tagId: 7007,
        rules: {
            applicationId: true,
        },
        featureName: 'Lienholder',
        tagName: 'lender updates save success',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.LIENHOLDER_LENDER_UPDATES_SAVE_FAILED]: {
        eventType: EventType.UI,
        tagDescription: 'System fails to save user updates',
        tagId: 7008,
        rules: {
            applicationId: true,
        },
        featureName: 'Lienholder',
        tagName: 'lender updates save failed',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.LENDER_CHECKOUT_PAYOFF_AMOUNT_PREFILLED]: {
        eventType: EventType.UI,
        tagDescription: 'System prefills payoff amount',
        tagId: 7009,
        rules: {
            applicationId: true,
        },
        featureName: 'Lender Checkout',
        tagName: 'payoff amount prefilled',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.LENDER_CHECKOUT_PAYOFF_AMOUNT_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User attempts to click payoff amount',
        tagId: 7010,
        rules: {
            applicationId: true,
        },
        featureName: 'Lender Checkout',
        tagName: 'payoff amount clicked',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
    },
    [TagKey.LENDER_CHECKOUT_UPDATE_LENDER_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Update lender" on lender edit component',
        tagId: 7011,
        rules: {
            applicationId: true,
        },
        featureName: 'Lender Checkout',
        tagName: 'update lender clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.LENDER_CHECKOUT_CANCEL_LENDER_CLICKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Cancel" on lender edit component',
        tagId: 7012,
        rules: {
            applicationId: true,
        },
        featureName: 'Lender Checkout',
        tagName: 'cancel lender clicked',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.LIENHOLDER_LENDER_INFO_CHANGED]: {
        eventType: EventType.UI,
        tagDescription: 'User changed lender info',
        tagId: 7013,
        rules: {
            applicationId: true,
        },
        featureName: 'Lienholder',
        tagName: 'lender info changed',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.LENDER_CHECKOUT_MISSING_INFORMATION_ALERT]: {
        eventType: EventType.UI,
        tagDescription: 'System shows missing information alert',
        tagId: 7014,
        rules: {
            applicationId: true,
        },
        featureName: 'Lender Checkout',
        tagName: 'missing information alert',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
    },
    [TagKey.LIENHOLDER_FIELD_VALIDATION_ERROR_MESSAGE]: {
        eventType: EventType.UI,
        tagDescription: 'User recieves invalid field criteria message',
        tagId: 7015,
        rules: {
            applicationId: true,
        },
        featureName: 'Lienholder',
        tagName: 'field validation error message',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.LENDER_CHECKOUT_LENDER_EDIT_ERROR_MESSAGE]: {
        eventType: EventType.UI,
        tagDescription: 'User recieves component error message',
        tagId: 7016,
        rules: {
            applicationId: true,
        },
        featureName: 'Lender Checkout',
        tagName: 'lender edit error message',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
    },
    [TagKey.VIEW_LENDER_CHECKOUT]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Lender Edit Component Shown',
        tagId: 7017,
        rules: {
            applicationId: true,
        },
        featureName: 'Lender Checkout',
    },
    [TagKey.LENDER_CHECKOUT_LENDER_MFE_LOAD]: {
        eventType: EventType.UI,
        tagDescription: 'System loads Lender MFE successfully',
        tagId: 7018,
        rules: {
            applicationId: true,
        },
        featureName: 'Lender Checkout',
        tagName: 'lender mfe load',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
        value: '${value}',
    },
    [TagKey.LENDER_CHECKOUT_LENDER_COMPONENT_COLLAPSED]: {
        eventType: EventType.UI,
        tagDescription: 'Lender edit component collapses',
        tagId: 7019,
        rules: {
            applicationId: true,
        },
        featureName: 'Lender Checkout',
        tagName: 'lender component collapsed',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.CUSTOMER_PROFILE_CUSTOMER_PROFILE_DOC_GENERATED]: {
        eventType: EventType.UI,
        tagDescription: 'System generates a customer profile document',
        tagId: 7020,
        rules: {
            applicationId: true,
        },
        featureName: 'Customer Profile',
        tagName: 'customer profile doc generated',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
};

export { PLUGINS, PRODUCT_NAME, PRODUCT_VERSION, TAG_CATALOG, TagKey };
